
import React from "react";
import { Badge, Card, CardActionArea, CardContent, Typography } from "@mui/material";
import { iconos } from "../../../data";



export const TarjetasOpciones = ({ onClickHandler, url, icono, titulo, subtitulo, cantidad=0 }) => {


    return (

        <Card elevation={3} sx={{width:'100%', textAlign:'center', borderRadius:'20px', height:'100%'}}>
            <CardActionArea sx={{height:'100%', px:1, py:2}} 
                onClick={() => onClickHandler?.(url) || null}
            >
                <CardContent>
                    {(cantidad > 0)
                    ?   <Badge badgeContent={cantidad} color="primary" overlap="circular" 
                            anchorOrigin={{vertical:'top', horizontal:'right'}}
                            sx={{'& .MuiBadge-badge': {color:'white', fontWeight:'bold'}}}
                        >
                            {React.cloneElement(iconos[icono], {style: {fontSize: 60}, color:'secondary'})}
                        </Badge>
                    :   React.cloneElement(iconos[icono], {style: {fontSize: 60}, color:'secondary'})
                    }
                    <Typography variant="h3" gutterBottom>{ titulo }</Typography>
                    {subtitulo && <Typography variant="h3" gutterBottom>{ subtitulo }</Typography>}
                </CardContent>
            </CardActionArea>
        </Card>

    )
}
